export default __webpack_public_path__ + "static/media/Github.f4777b87.svg";